<template>
  <button
    type="button"
    class="telegram-fab"
    :aria-label="$t('nav.telegramInquiry')"
    @click="$emit('telegram')"
  >
    <span class="telegram-fab__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="22" height="22">
        <path
          d="M21.5 3.5 2.8 11.2c-.9.4-.9 1.6.1 1.9l4.8 1.6 1.8 5.5c.3.9 1.5.9 1.8 0l2.1-6.3 6.4-6.4c.7-.7.2-1.9-.8-1.5Z"
          fill="currentColor"
        />
        <path
          d="M9.6 14.4 9.2 18l2.8-2.5"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <span class="telegram-fab__label">{{ $t('nav.telegramLiveSupport') }}</span>
  </button>
</template>

<script>
export default {
  name: 'BlackGoldTelegramFab',
  mounted () {
    if (typeof document !== 'undefined' && this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el)
    }
  },
  destroyed () {
    if (typeof document !== 'undefined' && this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  }
}
</script>
